var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "6px",
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-28.000000, -58.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Down",
    transform: "translate(28.250000, 58.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.06797,0.57891 L0.11016,0.62813 L3.29766,4.29609 C3.40547,4.42031 3.56719,4.49766 3.74766,4.49766 C3.92812,4.49766 4.08984,4.41797 4.19766,4.29609 L7.38281,0.63516 L7.43672,0.57422 C7.47656,0.51563 7.5,0.44531 7.5,0.37031 C7.5,0.16641 7.32656,0 7.11094,0 L0.38906,0 C0.17344,0 0,0.16641 0,0.37031 C0,0.44766 0.02578,0.52031 0.06797,0.57891 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.30f37208.svg";
export { ForwardRef as ReactComponent };